import React from 'react';
import Icon from '@gumtree/ui-library/src/icon/icon';
import { colors, fontWeights } from '@gumtree/ui-library/src/base/theme';
import { srpContactDetail } from '@gumtree/shared/src/model/ad-details.model';
import { SellerSkillItem } from '@gumtree/shared/src/model/listing.model';
import EmailContactButton from '../cta/EmailContactButton';
import PhoneContactButton from '../cta/PhoneContactButton';

import {
    Skills,
    SkillItem,
    SkillItemDesc,
    InfoWrapper,
    CtaWrapper,
} from './listing-tile-service.style';

export interface TileInfoContactProps {
    adId: number;
    isUserLoggedIn: boolean;
    sellerSkills?: SellerSkillItem[];
    imageUrl?: string;
    adSource?: string;
    title?: string;
    thirdPartySellerId?: string;
    allSellerSkills?: SellerSkillItem[];
    ctaData? : srpContactDetail;
    trackEventPayload?: GA4.GA4ListingDetails | {};
    updateRequestQuoteFormData?: {
        setProfile: (profile: string) => void;
        setTitle: (title: string) => void;
        setPreferredContactType: (preferredContactType: "quote" | "call") => void;
        setSellerId: (sellerId: string) => void;
        setAdvertId: (advertId: string) => void;
        setSellerSkills: (sellerSkills: any[]) => void;
        openModal: () => void;
    };
    requestId?: string;
}

const TileInfoContact = ({
    adId,
    isUserLoggedIn,
    sellerSkills,
    imageUrl,
    title,
    adSource,
    ctaData = {},
    trackEventPayload,
    thirdPartySellerId,
    allSellerSkills,
    updateRequestQuoteFormData,
    requestId,
}: TileInfoContactProps) => {
    return (
        <InfoWrapper>
            <Skills>
                {
                    sellerSkills && sellerSkills?.length > 0 && sellerSkills.map((item) => (
                        <SkillItem key={item.id}>
                            <Icon color={colors.newDarkGrey.toString()} type="checkMark" />
                            <SkillItemDesc>{item.description}</SkillItemDesc> 
                        </SkillItem>
                    )) 
                }
            </Skills>

            <CtaWrapper>
                {/* 电话按钮 */}
                <PhoneContactButton
                    style={{ marginTop: '10px' }}
                    buttonStyle={{ fontWeight: fontWeights.bold }}
                    id={adId.toString()}
                    userLoggedIn={isUserLoggedIn}
                    isUserLoggedIn={isUserLoggedIn}
                    // isUserLoggedIn={ctaData?.isUserLoggedIn}

                    isFromMotorsFeed={ctaData?.isFromMotorsFeed}
                    replyPhone={ctaData?.replyPhone}
                    revealSellerTelephoneNumberToken={ctaData?.revealSellerTelephoneNumberToken}
                    showRevealNumber={ctaData?.showRevealNumber}
                    isLoginRequiredToContactForVipCategory={ctaData?.loginRequiredToContactForVipCategory}
                    revealNumberUnmasked={ctaData?.revealNumberUnmasked}
                    revealPhoneCallbackUrl={ctaData?.revealPhoneCallbackUrl}
                    isCurrentUserSeller={ctaData?.currentUserSeller}
                    // 以下来自 baseConfig
                    domain={ctaData?.domain}
                    trackEventPayload={trackEventPayload}
                    adSource={adSource}
                    imageUrl={imageUrl}
                    title={title}
                    thirdPartySellerId={thirdPartySellerId}
                    allSellerSkills={allSellerSkills}
                    updateRequestQuoteFormData={updateRequestQuoteFormData}
                    requestId={requestId}
                />

                {/* 邮件按钮 */}
                <EmailContactButton
                    style={{ fontWeight: fontWeights.bold }}
                    adId={adId.toString()}
                    replyEmail={ctaData?.replyEmail}
                    isCurrentUserSeller={ctaData?.currentUserSeller}
                    isFromMotorsFeed={ctaData?.isFromMotorsFeed}
                    trackEventPayload={trackEventPayload}
                    adSource={adSource}
                    imageUrl={imageUrl}
                    title={title}
                    thirdPartySellerId={thirdPartySellerId}
                    allSellerSkills={allSellerSkills}
                    updateRequestQuoteFormData={updateRequestQuoteFormData}
                    requestId={requestId}
                />
            </CtaWrapper>
        </InfoWrapper>
    );
};

export default TileInfoContact;
